/* unplugin-vue-components disabled */import { render } from "./player.vue?vue&type=template&id=510e566f&scoped=true&ts=true"
import script from "./player.vue?vue&type=script&lang=ts"
export * from "./player.vue?vue&type=script&lang=ts"

import "./player.vue?vue&type=style&index=0&id=510e566f&lang=scss&scoped=true"

import exportComponent from "E:\\Workspaces\\VScode\\vue3+TS\\vue案例\\cloudMusicProject-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-510e566f"],['__file',"src/components/player/player.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "510e566f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('510e566f', __exports__)) {
    console.log('reload')
    api.reload('510e566f', __exports__)
  }
  
  module.hot.accept("./player.vue?vue&type=template&id=510e566f&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('510e566f', render)
  })

}


export default __exports__